// extracted by mini-css-extract-plugin
export default {"cls1":"AnswersMarketingButton-cls1__c9ff27fff3e31a4e51d2","cls2":"AnswersMarketingButton-cls2___4ab03fd6a84f0c91d70 AnswersMarketingButton-cls1__c9ff27fff3e31a4e51d2"};